import { API_SECURITY_URL } from '@/constants'
import { IAccessPermission, IPaginationParam, IPaginationResponse, IRole, IRoleGroupSetup, IUserAccountList } from '@/types'
import { createAxiosInstance } from '@/utils'
import { GenericAbortSignal } from 'axios'

const axios = createAxiosInstance({
  baseURL: API_SECURITY_URL,
  withAuth: true,
  headers: {
    'x-version-api': 1,
  },
})

export const fetchRoleGroupSetup = (params?: IPaginationParam, signal?: GenericAbortSignal) => {
  return axios.get<{ data: IRoleGroupSetup }>(`/role-group/setup`, { params, signal }).then((response) => response.data)
}

export const updateRoleGroup = (oid: string, payload: Record<string, any>) => {
  return axios.put<{ data: IRoleGroupSetup }>(`/role-group/${oid}`, payload).then((response) => response.data.data)
}

export const fetchRoleGroup = (oid: string) => {
  return axios.get<{ data: IAccessPermission }>(`/role-group/${oid}`).then((response) => response.data.data)
}

export const createRoleGroup = (payload: Record<string, any>) => {
  return axios.post<{ data: IRoleGroupSetup }>('/role-group', payload).then((response) => response.data.data)
}

export const deleteRoleGroup = (oid: string) => {
  return axios.delete<{ data: IRoleGroupSetup }>(`/role-group/${oid}`).then((response) => response.data.data)
}

export const fetchRoleGroups = (params?: IPaginationParam, signal?: GenericAbortSignal) => {
  return axios.get<{ data: IPaginationResponse<IRole> }>(`/role-group`, { params, signal }).then((response) => response.data.data)
}

/**
 * User Account List
 *
 */
export const fetchUserAccounts = (params?: IPaginationParam, signal?: GenericAbortSignal) => {
  return axios
    .get<{ data: IPaginationResponse<IUserAccountList> }>(`/user-account`, { params, signal })
    .then((response) => response.data.data)
}

export const fetchUserAccount = (oid: string) => {
  return axios.get<{ data: IUserAccountList }>(`/account/${oid}`).then((response) => response.data.data)
}

export const createUserAccount = (payload: Record<string, any>) => {
  return axios.post<{ data: IUserAccountList }>(`/account`, payload).then((response) => response.data.data)
}

export const updateUserAccount = (oid: string, payload: Record<string, any>) => {
  return axios.patch<{ data: IUserAccountList }>(`/user-account/${oid}`, payload).then((response) => response.data.data)
}

export const updateStatusUserAccount = (oid: string, payload: Record<string, any>) => {
  return axios.patch<{ data: IUserAccountList }>(`/user-account/active/${oid}`, payload).then((response) => response.data.data)
}

export const deleteUserAccount = (oid: string) => {
  return axios.delete(`/account/${oid}`).then((response) => response.data.data)
}
